module.exports = __webpack_public_path__ + "static/media/2DGACM5.815a1a85.jpg";